var getNamedNavigationTree = function getNamedNavigationTree(navigationTree) {
  var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  return navigationTree.map(function (n, i) {
    return Object.assign(Object.assign({}, n), {
      name: n.name || "".concat(path).concat(i),
      children: n.children ? getNamedNavigationTree(n.children, "".concat(path).concat(i, "-")) : undefined
    });
  });
};

export { getNamedNavigationTree };
